var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPartition(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 94,
    height: 88,
    viewBox: "0 0 93.32 88.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1,.cls-4{fill:none;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-7{stroke:#273133;stroke-miterlimit:10;}.cls-1,.cls-2{stroke-width:1.82px;}.cls-2,.cls-3,.cls-5,.cls-7{fill:none;}.cls-3,.cls-4{stroke-width:1.88px;}.cls-5{stroke-width:1.79px;}.cls-6{fill:#273133;}.cls-7{stroke-width:1.88px;}\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#273133",
    className: "cls-1",
    d: "M70.85,51.19v11.4a13.6,13.6,0,0,0-4.93,15.06H38.42V51.19L55.29,44.6Z"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#273133",
    className: "cls-1",
    x: 41.71,
    y: 61.77,
    width: 5.44,
    height: 5.6
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#273133",
    className: "cls-1",
    d: "M50.22,78.53V63.77a2.61,2.61,0,0,1,2.61-2.61h5a2.61,2.61,0,0,1,2.61,2.61V78.56"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#273133",
    className: "cls-1",
    d: "M58.63,57.1H52.06a1.79,1.79,0,0,1-1.78-1.79V52.13a1.78,1.78,0,0,1,1-1.59l3.29-1.69a1.82,1.82,0,0,1,1.64,0l3.27,1.69a1.78,1.78,0,0,1,1,1.59v3.18A1.79,1.79,0,0,1,58.63,57.1Z"
  }), /*#__PURE__*/React.createElement("line", {
    stroke: "#273133",
    className: "cls-1",
    x1: 55.36,
    y1: 48.51,
    x2: 55.36,
    y2: 57.02
  }), /*#__PURE__*/React.createElement("line", {
    stroke: "#273133",
    className: "cls-1",
    x1: 60.28,
    y1: 53.15,
    x2: 50.49,
    y2: 53.15
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    stroke: "#273133",
    points: "71.27 52.38 73.72 52.36 73.69 49.23 55.28 41.04 35.65 49.02 35.61 52.23 38.14 52.19"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    stroke: "#273133",
    points: "15.52 36.23 3.64 36.23 3.64 10.78 19.87 4.44 34.84 10.78 34.84 36.23 24.29 36.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    stroke: "#273133",
    d: "M15,37.17l0-14.29a2.51,2.51,0,0,1,2.51-2.51H22.3a2.51,2.51,0,0,1,2.51,2.51v14.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    stroke: "#273133",
    points: "33.88 14.26 37.6 14.23 37.57 8.89 19.87 1.02 0.98 8.69 0.95 14.1 4.56 14.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    stroke: "#273133",
    d: "M82.53,79.22a6.69,6.69,0,0,1-3,.71,6.57,6.57,0,1,1,3.27-12.26"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    stroke: "#273133",
    x1: 71.51,
    y1: 72.07,
    x2: 78.43,
    y2: 72.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    stroke: "#273133",
    x1: 71.51,
    y1: 74.66,
    x2: 78.43,
    y2: 74.66
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    stroke: "#273133",
    d: "M70.85,62.59a13.57,13.57,0,1,1-4.93,15.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    fill: "#273133",
    d: "M69.05,35.14l3.22,3.78a.83.83,0,0,0,.55.27.8.8,0,0,0,.57-.2l3.77-3.44-1-1.14L72.93,37.3l-2.7-3.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    stroke: "#273133",
    d: "M73.06,37.41A31.23,31.23,0,0,0,73,30.32C71.11,16.2,58.57,3.06,43.12,3.41"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartition);
export default __webpack_public_path__ + "static/media/partition.24d22636a43240d95d12c2feb8fe4bbb.svg";
export { ForwardRef as ReactComponent };